"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const InstagramIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.156 4.831a.906.906 0 100-1.812.906.906 0 000 1.812z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M8 4.019c-2.188 0-4 1.781-4 4 0 2.219 1.781 4 4 4 2.219 0 4-1.813 4-4 0-2.188-1.813-4-4-4zm0 6.562A2.574 2.574 0 015.437 8.02 2.574 2.574 0 018 5.456a2.574 2.574 0 012.563 2.563A2.574 2.574 0 018 10.58z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M11.219.3c1.312 0 2.469.437 3.281 1.281.813.813 1.25 1.938 1.25 3.25v6.438c0 1.344-.438 2.5-1.281 3.312-.813.782-1.938 1.219-3.281 1.219H4.811c-1.28 0-2.406-.406-3.25-1.219-.875-.843-1.312-2-1.312-3.343V4.83C.25 2.112 2.063.3 4.781.3h6.438zm2.25 13.25c.562-.531.906-1.313.906-2.281V4.83c0-.906-.313-1.687-.844-2.25-.562-.562-1.344-.844-2.281-.844H4.812c-.937 0-1.75.282-2.28.813-.563.562-.845 1.344-.845 2.281v6.407c0 .968.282 1.75.844 2.312.563.531 1.344.813 2.281.813h6.375c.938 0 1.72-.282 2.282-.813z",
    clipRule: "evenodd"
  })))
});
InstagramIcon.displayName = 'InstagramIcon';
var _default = exports.default = InstagramIcon;